import { LENGTH_MAX } from '../components/CreateReview/constants/common';
import { TERMS } from '../constants/terms';
import { plur } from '../helpers/plur';

export enum ERRORS {
  INVALID_EMAIL_ADDRESS = 'invalidEmailAddress',
  INVALID_PHONE = 'invalidPhone',
  INVALID_DATE = 'invalidDate',
  INVALID_NAME = 'invalidName',

  // ошибки типа
  MUST_BE_A_NUMBER = 'mustBeANumber',

  // ошибки текста
  REPEATING_CHARS = 'repeatingChars',

  // ошибки обязательного поля
  REQUIRED_FIELD = 'requiredField',
  REQUIRED_RATING = 'requiredRating',
  REQUIRED_ORGANIZATION = 'requiredOrganization',

  // ошибки кол-ва символов
  MIN_REVIEW_TEXT = 'minReviewText',
  MAX_REVIEW_TEXT = 'maxReviewText',

  // ошибки необходимости заполнить сначала другие поля
  CHOOSE_ORG_TYPE = 'chooseOrgType',
  CHOOSE_ORG_TYPE_ORG_SERVICE = 'chooseOrgTypeOrgService',
}

export const ERROR_DICTIONARY = {
  [ERRORS.INVALID_EMAIL_ADDRESS]: 'Неверный адрес электронной почты',
  [ERRORS.INVALID_PHONE]: 'Неверный номер телефона',
  [ERRORS.INVALID_DATE]: 'Неверная дата',
  [ERRORS.INVALID_NAME]: 'Проверьте поле',

  // ошибки типа
  [ERRORS.MUST_BE_A_NUMBER]: 'Должен быть числом',

  // ошибки текста
  [ERRORS.REPEATING_CHARS]: 'Не должно быть одинаковых символов, повторяющихся более 3 раз',

  // ошибки обязательного поля
  [ERRORS.REQUIRED_FIELD]: 'Заполните поле',
  [ERRORS.REQUIRED_RATING]: 'Заполните оценку',
  [ERRORS.REQUIRED_ORGANIZATION]: 'Выберите организацию',

  // ошибки кол-ва символов
  [ERRORS.MIN_REVIEW_TEXT]: 'Попробуйте добавить информации и контекста, чтобы отзыв был полезен другим пользователям',
  [ERRORS.MAX_REVIEW_TEXT]: `Вы вышли за ${LENGTH_MAX['text']} знаков! Попробуйте оставить главное и сократить текст`,

  // ошибки необходимости заполнить сначала другие поля
  [ERRORS.CHOOSE_ORG_TYPE]: 'Сначала выберите тип организации',
  [ERRORS.CHOOSE_ORG_TYPE_ORG_SERVICE]: 'Сначала выберите тип организации, организацию и услугу',
};

export const makeMaxLengthMessage = (value: number) =>
  `Максимум ${value} ${plur({
    value,
    initialForm: false,
    unit: TERMS.symbols,
  })}`;

export const makeMinLengthMessage = (value: number) =>
  `Минимум ${value} ${plur({
    value,
    initialForm: false,
    unit: TERMS.symbols,
  })}`;

export const makeMaxAgeMessage = (value: number) =>
  `Вам должно быть меньше ${value} ${plur({
    value,
    initialForm: false,
    unit: TERMS.years,
  })}`;

export const makeMinAgeMessage = (value: number) =>
  `Вам должно быть больше ${value} ${plur({
    value,
    initialForm: false,
    unit: TERMS.years,
  })}`;

export const OK_TEXTS = {
  TEXT_GOOD: 'Отлично, но можете дополнить, если хотите',
  TEXT_NOT_ENOUGH: 'Попробуйте добавить информации и контекста, чтобы отзыв был полезен другим пользователям',
};
